import { Component, Input } from '@angular/core';
import { BreezeViewService } from '@common/services/breeze-view.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { UploadActionButtonsComponent } from '@common/components/upload-action-buttons.component';
import _ from 'lodash';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-user-notification-list',
    templateUrl: './user-notification-list.component.html',
    styleUrls: ['./user-notification-list.component.scss'],
    providers: [BreezeViewService]
})
export class UserNotificationListComponent {
    notifications = [];
    @Input() showHeader = true;
    @Input() onlyImportant = false;

    breadcrumb = [
        {
            icon: 'file',
            title: 'Notice board'
        }
    ];

    constructor(private http: HttpClient, private breezeViewService: BreezeViewService) {
        breezeViewService.handleQuery('UserNotifications')
            .then((notifications) => this.notifications = this.onlyImportant ? _.filter(notifications, n => n.important) : notifications);
    }

    async download(event, id) {
        event.preventDefault();
        const attachment: any = await firstValueFrom(this.http.get(`${environment.settings.appControl.fileDownloadUrl}?id=${id}`));
        UploadActionButtonsComponent.download(attachment.name, attachment.content);
    }
}
